import { FC, useState, useContext, useEffect } from "react";

import { BoardContext, TeamContext, UserContext } from "../../../../context";

import { FrontSide } from "../../../atoms";

import { ICard } from "../../../../interfaces";
import { CardType } from "../../../../util/enums";

interface CardSlotProps {
    card?: ICard;
    isForceHoverOn?: boolean;
    solutionCardsInHands?: boolean;
    fullScreenIsOn?: boolean;
}

const CardSlot: FC<CardSlotProps> = ({ card, isForceHoverOn, solutionCardsInHands, fullScreenIsOn}) => {
    const { game } = useContext(TeamContext);
    const { setDisplayModalData } = useContext(BoardContext);
    const { emailOfSelectedPlayerBoard } = useContext(UserContext);
    const [deckOfSolutions, setDeckOfSolutions] = useState<ICard[] | []>([]);

    const selectedUserCardData = game?.gameInfo.players[emailOfSelectedPlayerBoard];
    const strengthToSolution = selectedUserCardData?.strengthToSolution;
    let solutionCombinationsForThisCard: any = [];

    const displayModal = (solutionCombinationsForThisCard: any, card: any) => {
        setDisplayModalData({solutionCombinationsForThisCard: solutionCombinationsForThisCard, card: card })
    }

    useEffect(() => {
        if (card?.type !== CardType.STRENGTH) {

            if (card?.id !== deckOfSolutions[deckOfSolutions.length - 1]?.id) {
                setDeckOfSolutions([...deckOfSolutions, card!]);
            }
        }
    }, [card, deckOfSolutions]);

    if (!strengthToSolution) return <div></div>

    if (strengthToSolution[card?.id || ""])
        solutionCombinationsForThisCard = strengthToSolution[card?.id || ""];
    
    return (
        <div style={{ height: "100%" }}>
            {(solutionCombinationsForThisCard.length !== 0) &&
                <div className="listOfSolutions_wrapper">
                    <div onClick={() => displayModal(solutionCombinationsForThisCard, card)} className="listOfSolutions">
                       <div className="center_horizontally_and_vertically" style={{height: "30px"}}>
                            <div className="solutions">{solutionCombinationsForThisCard.length}</div>
                        </div>
                    </div>
                </div>
            }
            {card && (
                <FrontSide
                    cardData={card}
                    isForceHoverOn={isForceHoverOn}
                    solutionCardsInHands={solutionCardsInHands}
                    fullScreenIsOn={fullScreenIsOn}
                />
            )}
            
        </div>
    );
};

export default CardSlot;